import React from 'react'
import { SuccessPage } from 'components'

export default function TTDSuccess() {
  return <SuccessPage />
}
